import { render, staticRenderFns } from "./TitleScreen.vue?vue&type=template&id=238d6fc6&scoped=true"
import script from "./TitleScreen.vue?vue&type=script&lang=ts"
export * from "./TitleScreen.vue?vue&type=script&lang=ts"
import style0 from "./TitleScreen.vue?vue&type=style&index=0&id=238d6fc6&prod&lang=less"
import style1 from "./TitleScreen.vue?vue&type=style&index=1&id=238d6fc6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238d6fc6",
  null
  
)

export default component.exports